import { priorityOptions } from 'keys/priority'
import { requestTypeOptions } from 'keys/requestTypes'

const useFields = () => {

    const isAuthFormFields = [
        {
            name: "ticket_type",
            placeholder: "הודעה מסוג",
            component: "autoComplete",
            options: requestTypeOptions
        },
        {
            name: "title",
            component: "input",
            placeholder: "כותרת",
            fullWidth: true
        },
        {
            name: "description",
            component: "input",
            label: "כאן המקום להרחיב",
            placeholder: "כמה שיותר פרטים יותר טוב",
            fullWidth: true,
            rows: 4
        },
        {
            name: "priority",
            placeholder: "אני פונה כי הנושא:",
            component: "autoComplete",
            options: priorityOptions,
            labelKey: "label"
        },
        {
            name: "image",
            component: "uploadFile",
            label: "תמונה",
            type: "image",
        }
    ]

    const formFields = [
        {
            name: "title",
            component: "input",
            placeholder: "כותרת",
            fullWidth: true
        },
        {
            name: "description",
            component: "input",
            label: "כאן המקום להרחיב",
            placeholder: "כמה שיותר פרטים יותר טוב",
            fullWidth: true,
            rows: 4
        },
        {
            name: "email",
            component: "input",
            placeholder: "המייל שלכם",
            fullWidth: true
        }
    ]


    return { formFields, isAuthFormFields }
}

export default useFields